import { Button } from "react-bootstrap";

export default function ResponseView({ response, setCurrentScreen }) {
  let successfulEmails = [];
  let unsuccessfulEmails = [];
  if (Array.isArray(response.message) && response?.message?.length > 0) {
    successfulEmails = response?.message?.filter(
      (msg) => msg.accepted.length > 0
    );
    unsuccessfulEmails = response?.message?.filter(
      (msg) => msg.rejected.length > 0
    );
  }
  return (
    <>
      <div className="row g-0">
        <div className="col-6 pt-3 justify-content-start d-flex align-items-center">
          <Button
            className="font-bold"
            size="sm"
            variant="danger"
            onClick={() => setCurrentScreen("Select Emails")}
          >
            {"Back to Edit List"}
          </Button>
        </div>
        <div className="col-6 justify-content-end d-flex"></div>
      </div>
      <div className="row g-0">
        {response?.message?.length > 0 ? <>
        <h2 className="ps-2">Total Emails: {response.message.length}</h2>
        <div className="m-2 col-12 col-lg-6 justify-content-start align-items-start text-start d-flex flex-column bg-light">
          <h2 className="ps-2">Successful Emails({successfulEmails.length}):</h2>
          <ul>
            {successfulEmails?.map((msg, index) => (
              <p key={index}>{msg.envelope.to},</p>
            ))}
          </ul>
        </div>
        <div className="m-2 ms-lg-5 col-12 col-lg-5 justify-content-start align-items-start text-start d-flex flex-column bg-light">
          <h2 className="ps-2">Unsuccessful Emails({unsuccessfulEmails.length}):</h2>
          <ul>
            {unsuccessfulEmails?.map((msg, index) => (
              <p key={index}>{msg.envelope.to},</p>
            ))}
          </ul>
        </div>
        </> : response?.message?.status ? <><h2 className="ps-2">Emails scheduled for Mailgun</h2> <div>Mailgun Response: <strong>{response?.message?.message}</strong></div></> :<> <h2 className="ps-2">Mailgun Api Failure</h2> <div>Mailgun Error Response: <strong>{response?.message?.message}</strong></div></>}
      </div>
    </>
  );
}
